import React, { Component } from "react";
import { Link } from "react-router-dom";
import calcularPx from "../calcularPx.js";
import { ReactComponent as IcoLogout } from "../../../res/iconos/logout.svg";

class AccesoDesktop extends Component {
  state = { nivel: this.props.nivelLogin };

  componentDidUpdate(prevProps) {
    if (prevProps.nivelLogin != this.props.nivelLogin) {
      this.setState({ nivel: this.props.nivelLogin });
    }
  }

  render() {
    return (
    <div 
      style={
      {
        position: "absolute",
        marginLeft: -90+12.5,
        //marginRight: "auto",
        top: calcularPx(102),
        width: 180,
        height: "auto",
        display: "flex",
        justifyContent: "space-between",
        background: "#FFFFFF",
        paddingLeft: 30,
        paddingTop: 30,
        paddingBottom: 30,
        paddingRight: 30,
        borderBottomLeftRadius: 25,
        borderBottomRightRadius: 25,
        borderBottom: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#e5e8e9",
        borderLeft: "solid",
        borderLeftWidth: 1,
        borderLeftColor: "#e5e8e9",
        borderRight: "solid",
        borderRightWidth: 1,
        borderRightColor: "#e5e8e9"
      }}
    >
      {
        this.state.nivel != 0 ?
        <div>          
          <Link
            onClick={this.props.ocultar}
            to={this.state.nivel == 2 ? "/admin" : "/clientes"}
          >
            <div className="categoria_submenu" style={{textAlign: "left",
              width: "100%"}}>
              {this.state.nivel == 2 ? "Administración" : "Zona Clientes"}
            </div>
          </Link>
          <div style={{width: "100%", height: 10}}/>
          <button
            className="categoria_submenu"
            style={{
              textAlign: "left",
              width: "100%",
              border: "none",
              background: "transparent",
            }}
            onClick={() => {
              this.props.ocultar();
              this.props.botones.cerrarSesion();
            }}
          >
            Salir
            <IcoLogout
              style={{ marginLeft: 15 }}
              width={25}
              height={25}
            />
          </button>
        </div>
        :
        <div>          
          <button
            className="categoria_submenu"
            style={{
              textAlign: "left",
              width: "100%",
              border: "none",
              background: "transparent",
            }}
            onClick={() => {
                this.props.ocultar();
                this.props.botones.ingresar();
              }}
          >
            Ingresar
          </button>
          <div style={{width: "100%", height: 10}}/>
          <button
            className="categoria_submenu"
            style={{
              textAlign: "left",
              width: "100%",
              border: "none",
              background: "transparent",
            }}
            onClick={() => {
                this.props.ocultar();
                this.props.botones.registrar();
              }}
          >
            Crear cuenta
          </button>
        </div>
      }
      
    </div>)
  };
};

export default AccesoDesktop;
